<template>
  <div id="wrap">
    <!-- logo -->
    <div class="logo"></div>
    <!-- title -->
    <div class="title">二手优品</div>
    <div class="text">一站式手机服务平台商，围绕隐私安全技术、智能检测技术与二手机行业供应链能力，打破二手行业信息壁垒，为用户提供高性价比的二手机与周边服务。</div>
    <!-- 格子区域 -->
    <div class="lattice">
      <!-- <div class="top">
        <div class="left">品牌出口</div>
        <div class="right">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="content">
        <div class="left">
          同
          <br />城
          <br />帮
          <br />中
          <br />台
        </div>
        <div class="right">
          <div>
            <div>订单系统</div>
            <div>用户中心</div>
            <div>货仓连动</div>
          </div>
          <div>质检系统</div>
          <div>仓储系统</div>
          <div>
            <div>天机汇云仓系统</div>
            <div>B端信用体系</div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="left">资源整合</div>
        <div class="right">
          <div>C端用户</div>
          <div>小B供应链</div>
          <div>大B供应链</div>
          <div>云仓供应链</div>
        </div>
      </div>-->
    </div>
    <!-- 展示栏 -->
    <div class="displayBar1">
      <div class="img"></div>
      <div class="content">
        <div class="title">苏宁二手</div>
        <div
          class="text"
        >苏宁二手由同城帮独家代理，拥有大量优质的苏宁备件库、苏宁二手等电子设备资源储备，结合同城帮线上线下产业供应能力，为普通消费者提供高性价比二手数码产品服务。</div>
      </div>
    </div>
    <!-- 第二个展示栏 -->
    <div class="displayBar2">
      <div class="content">
        <div class="title">闲鱼优品</div>
        <div class="text">同城帮与闲鱼优品联合运营，通过同城帮强大产业链供应能力与上下游生态赋能，结合闲鱼优品品牌能力，为阿里平台提供二手数码采买解决方案。</div>
      </div>
      <div class="img"></div>
    </div>
    <!-- 展示栏 -->
    <div class="displayBar3">
      <div class="img"></div>
      <div class="content">
        <div class="title">同城帮优品</div>
        <div class="text">同城帮优品是同城帮的二手电子设备售卖平台。平台售卖产品均经过严格的质量筛选，及7天无理由退货等服务，保证您买的放心。</div>
      </div>
    </div>
    <!-- 第二个展示栏 -->
    <div class="displayBar4">
      <div class="content">
        <div class="title">二手优品</div>
        <div class="text">结合人工智能检测、质检技术，为二手数码产业提供行业高效、高精准、低成本全自动化运营服务能力，赋能上下游合作伙伴，提供业内优质二手数码C端供应保障。</div>
      </div>
      <div class="img"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#wrap {
  //   background-color: skyblue;
  .logo {
    width: 70px;
    height: 70px;
    background-image: url("https://p3.ssl.qhimg.com/t01c8f44def2f3e4341.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 30px;
  }
  .title {
    color: #000000;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .text {
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 60px;
  }
  // 格子区域
  .lattice {
    width: 1034px;
    height: 584px;
    background-image: url("https://p4.ssl.qhimg.com/t011db7a857ef79e3a2.png");
    background-repeat: no-repeat;
    background-size: auto;
    text-align: center;
    line-height: 82px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 60px;
    .top {
      width: 100%;
      height: 82px;
      display: flex;
      .left {
        width: 135px;
        height: 100%;
        background-color: #cf2c28;
        line-height: 82px;
        text-align: center;
        margin-right: 18px;
        font-size: 18px;
        color: #fff;
        font-weight: 600;
      }
      .right {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        div {
          width: 205px;
          height: 100%;
          background-repeat: no-repeat;
          background-size: cover;
          border: 1px solid #aaaaaa;
        }
        div:nth-child(1) {
          background-image: url("../../assets/imgs/product/suning1.png");
        }
        div:nth-child(2) {
          background-image: url("../../assets/imgs/product/youpin.png");
        }
        div:nth-child(3) {
          background-image: url("../../assets/imgs/product/tongchengbang.png");
        }
        div:nth-child(4) {
          background-image: url("../../assets/imgs/product/360.png");
        }
      }
    }
    .content {
      height: 384px;
      margin: 18px 0;
      display: flex;
      font-size: 18px;
      font-weight: 600;
      color: white;

      .left {
        width: 135px;
        height: 100%;
        background-color: #26c9a5;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 18px;
      }
      .right {
        height: 100%;
        width: 100%;
        line-height: 82px;
        text-align: center;
        > div:nth-child(1) {
          display: flex;
          justify-content: space-between;
          margin-bottom: 18px;
          div {
            width: 280px;
            height: 82px;
            background-color: #26c9a5;
          }
        }
        > div:nth-child(2),
        > div:nth-child(3) {
          background-color: #26c9a5;
          margin-bottom: 19px;
        }
        > div:nth-child(4) {
          display: flex;
          justify-content: space-between;
          div {
            width: 430px;
            height: 82px;
            background-color: #26c9a5;
          }
        }
      }
    }
    .bottom {
      height: 82px;
      width: 100%;
      display: flex;
      .left {
        width: 135px;
        height: 100%;
        background-color: #cf2c28;
        margin-right: 18px;
        color: #fff;
        background-color: #478aff;
      }
      .right {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: space-between;
        div {
          width: 205px;
          height: 82px;
          background-color: #478aff;
        }
      }
    }
  }
  //   展示区
  .displayBar1 {
    width: 1034px;
    height: 321px;

    display: flex;
    margin-bottom: 60px;
    box-shadow: 0px 0px 20px #eee;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("https://p0.ssl.qhimg.com/t01da47fbd803d414b9.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 77px 64px 110px 51px;
      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  //   第二个展示区
  .displayBar2 {
    width: 1034px;
    height: 321px;
    box-shadow: 0px 0px 20px #eee;
    display: flex;
    margin-bottom: 60px;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("../../assets/imgs/product/xyyp.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 78px 53px 110px 64px;

      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
        text-align: right;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  //   展示区
  .displayBar3 {
    width: 1034px;
    height: 321px;
    box-shadow: 0px 0px 20px #eee;
    display: flex;
    margin-bottom: 60px;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("https://p3.ssl.qhimg.com/t0131607dd6cb8b8bfd.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 77px 64px 110px 51px;
      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  //   第二个展示区
  .displayBar4 {
    width: 1034px;
    height: 321px;
    display: flex;
    margin-bottom: 60px;
    box-shadow: 0px 0px 20px #eee;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("https://p0.ssl.qhimg.com/t01094b8c2134445807.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 78px 53px 110px 64px;

      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
        text-align: right;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
}
</style>
